import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ReservationVehicle } from '@user-history/entities/history-booking-detail';
import { AbandonedReservationsAbstract } from '@abandoned-reservation/abstracts/abandoned-reservations.abstract';

@Component({
  selector: 'app-abandoned-auto-reservation',
  templateUrl: './abandoned-auto-reservation.component.html',
  styleUrls: ['./abandoned-auto-reservation.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class AbandonedAutoReservationComponent extends AbandonedReservationsAbstract  {

  constructor() {
    super()
  }

  get reservation(): ReservationVehicle {
    return this.itinerary && this.itinerary.Reservations ?
      this.itinerary.Reservations[this.itinerary.Reservations.length - 1] as ReservationVehicle : {} as ReservationVehicle;
  }
}
